import { imageOpt, images } from '@/utils/images';
import { Box, Center, Flex, Group, Stack } from '@mantine/core';
import { addRefParam, emojiSource, isDark } from '@/utils/utils';

import DMText from '@/components/DMText';
import Image from 'next/image';
import TechstackAvatarBadgeGroup from '@/components/TechstackAvatarBadgeGroup';
import themeVariables from '@/styles/themeVariables';
import { useDiscoveryContentDetailModalStyle } from '@/features/Discovery/discovery.style';
import { useGetContentDetail } from '../hook/api';
import Button, { ButtonTypes } from '@/components/Buttons/Button';
import { mixpanelTrack } from '@/utils/mixpanel';

const TextBody = () => {
  const { dark } = isDark();
  const { classes } = useDiscoveryContentDetailModalStyle({ dark });
  const { data } = useGetContentDetail();

  return (
    <div className={classes.bodyContainer}>
      <Box className={classes.techstack} mt={10} mb={30}>
        {data?.content?.techstacks.length || 0 > 0 ? (
          <TechstackAvatarBadgeGroup techstacks={data?.content?.techstacks} />
        ) : (
          <Flex align={'center'} gap={6}>
            <DMText size={14} dColor={themeVariables.darkMode.neutral} mt={2}>
              * 관련 기술 스택이 없습니다
            </DMText>
            <Image
              width={16}
              height={16}
              src={emojiSource('1f605', 'twitter')}
              alt="emoji"
            />
          </Flex>
        )}
      </Box>
      {/* {data?.content?.has_detail ? (
        <Stack w={'100%'}>
          <Markdown
            remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
            components={{
              code: (props) => {
                const { children, className, ...rest } = props as any;
                const match = /language-(\w+)/.exec(className || '') || [
                  '',
                  'javascript',
                ];

                return (
                  <CodeBlock
                    code={String(children).replace(/\n$/, '')}
                    language={match[1]}
                    shadow
                    padding="12px 4px"
                    style={{
                      margin: '5px 0px',
                    }}
                  />
                );
              },
              img: ({ src }) => (
                <Image
                  width={0}
                  height={0}
                  src={src || BLUR_URL}
                  style={{ width: '100%', height: 'auto' }}
                  alt=""
                />
              ),
              blockquote: ({ children }) => (
                <Box
                  bg={
                    dark
                      ? themeVariables.colors.indigo100
                      : themeVariables.colors.light100
                  }
                  sx={{ padding: '0.5rem 1.5rem', borderRadius: 8 }}
                >
                  <Flex gap={24}>
                    <Box py={'1rem'}>
                      <Divider
                        w={6}
                        h={'100%'}
                        bg={themeVariables.colors.primary100}
                        orientation="vertical"
                        sx={{ borderRadius: 2 }}
                      />
                    </Box>
                    <Stack spacing={0}>
                      <DMText dColor={themeVariables.darkMode.normal}>
                        {children}
                      </DMText>
                    </Stack>
                  </Flex>
                </Box>
              ),
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              //@ts-ignore
              p: ({ children }) => {
                console.log(children);
                if (
                  typeof children === 'string' &&
                  children.indexOf('==') !== -1
                )
                  return (
                    <DMText
                      dColor={themeVariables.label.normal}
                      sx={{
                        width: 'fit-content',
                        backgroundColor: '#ffe359',
                      }}
                    >
                      {children.replaceAll('==', '')}
                    </DMText>
                  );

                return children;
              },
            }}
          >
            {data?.content?.text}
          </Markdown>
        </Stack>
      ) : ( */}
      <p className={classes.bodyText}>
        {data?.content?.summary ? (
          data?.content.summary.split('\n').map((line, index) => (
            <DMText
              key={index}
              dColor={themeVariables.darkMode.normal}
              sx={{
                fontSize: 15,
                fontWeight: 400,
              }}
            >
              {line}
              <br />
            </DMText>
          ))
        ) : (
          <>
            <Stack align={'center'} mt={40} spacing={8}>
              <Image
                width={240}
                height={240}
                src={images.processingGif}
                alt="process"
                quality={100}
              />
              <DMText
                weight={600}
                size={16}
                dColor={themeVariables.darkMode.normal}
              >
                네 줄 요약을 생성하고 있는 중이에요
              </DMText>
              <DMText weight={500} dColor={themeVariables.darkMode.normal}>
                잠시 후 다시 확인해주세요
              </DMText>
            </Stack>
          </>
        )}
      </p>
      <Center mt={40}>
        <Box pos={'relative'} className={classes.bodyImageContainer}>
          <Group
            id={'overlay'}
            position={'center'}
            className={classes.bodyImageOverlay}
            onClick={() => {
              mixpanelTrack('DiscoveryDetailModal_OpenUrlButton', 'Clicked', {
                id: data?.content?.id,
              });
              window.open(addRefParam(data?.content.url), '_blank');
            }}
          >
            <Button type={ButtonTypes.bordered}>지금 바로 읽기</Button>
          </Group>
          <Image
            width={0}
            height={0}
            className={classes.bodyImage}
            src={imageOpt(data?.content?.image_url, 480, 95) || ''}
            alt="thumbnail"
            priority
          />
        </Box>
      </Center>
      {/* )} */}
    </div>
  );
};

export default TextBody;
